



































import { Component, Prop, Vue } from 'vue-property-decorator';
import router from '@/router';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component({})
export default class EventViewTabSelector extends Vue {
  @Prop()
  private loading!: boolean;

  private get isCalendarPage(): boolean {
    return this.$route.path.includes(PAGE_PATH_BY_NAME.eventCalendarForMonth);
  }
  private get isListPage(): boolean {
    return this.$route.path.includes(PAGE_PATH_BY_NAME.eventList);
  }
  private goToCalendarPage() {
    if (!this.isCalendarPage) {
      return router.push(PAGE_PATH_BY_NAME.eventCalendarForMonth);
    }
  }
  private goToListPage() {
    if (!this.isListPage) {
      return router.push(PAGE_PATH_BY_NAME.eventList);
    }
  }
}
